import { toByteArray } from 'base64-js';
import * as pdfjsLib from 'pdfjs-dist';
import { awaitAllSafely, isNullOrUndefined } from '@weft/utils';
import React from 'react';
import { useQuery } from 'react-query';
import { Spinner } from '../../../design/Spinner';
import { PdfViewerPage } from './pdf-viewer-components/PdfViewerPage';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  './pdf.worker.min.mjs',
  import.meta.url,
).toString();

type PdfViewerProps = {
  base64EncodedPdf: string;
};

export const PdfViewer: React.FC<PdfViewerProps> = ({ base64EncodedPdf }) => {
  const { data: pages } = usePdfPages(base64EncodedPdf);

  if (isNullOrUndefined(pages)) {
    return <Spinner/>;
  }

  return (
    <>
      {
        pages.map(page => (
          <PdfViewerPage
            key={crypto.randomUUID()}
            page={page}
          />
        ))
      }
    </>
  );
};

function usePdfPages(base64EncodedPdf: string) {
  return useQuery({
    queryKey: ['pdf', base64EncodedPdf],
    queryFn: async () => {
      const pdfByteArray = toByteArray(base64EncodedPdf);
      const pdfDocument = await pdfjsLib.getDocument({ data: pdfByteArray }).promise;
      const totalPages = pdfDocument.numPages;

      return awaitAllSafely(
        ...Array.from({ length: totalPages }, (_, i) => pdfDocument.getPage(i + 1)),
      );
    },
  });
}